export enum StorageKeyEnum {
  META_TAG_LIST_DATA_KEY = 'META_TAG_LIST_DATA_KEY',
  COMIC_NAME_LIST_DATA_KEY = 'COMIC_NAME_LIST_DATA_KEY',
  LEGACY_META_TAG_LIST_DATA_KEY = 'META_TAG_LIST_DATA', //TODO: 레거시 localStorage 제거용 코드. 16차 스프린트 작업시 제거
  LEGACY_COMIC_NAME_LIST_DATA_KEY = 'COMIC_LIST_DATA_KEY' //TODO: 레거시 localStorage 제거용 코드. 16차 스프린트 작업시 제거
}
